var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-box"},[_c('img',{attrs:{"src":require("@/assets/img/images/mall-list-nodata.png"),"alt":"mall-list-nodata.png"}}),_c('p',[_vm._v(_vm._s(_vm.$t("mall.detail.noData")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }